import {assert} from 'assert-ts';
import {useAppSelector} from 'store/hooks';
import type {ExpressionV4} from '../types';
import {selectMetadataEditSavedMetadataExpressionById} from '../metadataEditSlice';
import {useCreateSelectorById} from './useCreateSelectorById';

export const useSavedExpression = (expressionId: string): ExpressionV4 => {
  const expression = useAppSelector(
    useCreateSelectorById(
      expressionId,
      selectMetadataEditSavedMetadataExpressionById,
    ),
  );

  if (!expression) {
    assert(false, 'useSavedExpression: unknown expressionId', {
      expressionId,
    });
  }

  return expression;
};
